import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Loading from '../common/Loading';
import Highcharts from 'highcharts/highstock';
import HC_exporting from 'highcharts/modules/exporting';
import HC_accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';

const metricList = [
  ['payments_count','Number of payments from one account to another'],
  ['payments_volume','XRP payment volume from one account to another'],
  ['active_users','Number of active users (SourceTag + DestinationTag)'],
  ['active_accounts','Number of active accounts (unique senders)'],
  ['fee_total','XRP burned as fees'],
  ['transaction_count','Number of transactions executed'],
  ['transaction_success_count','Number of successful transactions executed'],
  ['accounts_created','Number of new accounts created (activated)'],
  ['tx_per_ledger','Average number of transactions per ledger'],
  ['ledger_count','Number of closed ledgers'],
  ['ledger_interval','Average number of seconds between closed ledgers'],
];

const highchartsConfig = (data, keyName) => {
  return {
    // Chart settings
    chart: {
      scrollablePlotArea: { minWidth: 600 },
    },
    plotOptions: {
      series: {
        dataGrouping: {
          enabled: false
        }
      }
    },
    title: {
      text: keyName[1],
    },
    subtitle: {
      text: `(${keyName[0]})`,
    },
    rangeSelector: {
        selected: 4,
    },
    yAxis: {
      labels: {
        formatter: function() {
          if ( this.value >= 1000 * 1000 )
            return Highcharts.numberFormat( this.value/1000000, 1) + " M";
          if ( this.value >= 1000 )
            return Highcharts.numberFormat( this.value/1000, 1) + " K";
          else
            return Highcharts.numberFormat(this.value, 0);
        },
      },
    },

    // Responsive settings
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          chart: {
            height: 300
          },
          subtitle: {
            text: null
          },
          navigator: {
            enabled: false
          }
        }
      }]
    },

    // Export options
    exporting: {
      buttons: {
        contextButton: {
          menuItems: ['viewFullscreen', 'printChart'],
        },
      },
    },

    // Chart data
    series: [
    {
      name: keyName[0],
      type: 'areaspline',
      color: Highcharts.getOptions().colors[0],
      data: data,

      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, Highcharts.getOptions().colors[0]],
          [1, new Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
        ]
        }    
    }],
  }
};

class MetricMetric extends React.Component {
  constructor(props) {
    super(props);
    HC_exporting(Highcharts);
    HC_accessibility(Highcharts);
  }

  componentDidMount() {
  }

  getChartData(metric, name) {
    return metric.map((datapoint) => [new Date(datapoint.date).getTime(), (typeof datapoint.metric === 'object') ? datapoint.metric[name] : null]);
  }

  render() {
    const { metric } = this.props;

    if (metric && metric.length === 0) {
      return <Loading />
    }

    return (
      <div>
        <br/>
        {metricList.map((k,v) => {
          return (
            <Card className="shadow-sm" key={k}>
              <Card.Body>
                <HighchartsReact
                  highcharts={Highcharts}
                  constructorType={'stockChart'}
                  options={highchartsConfig(this.getChartData(metric, k[0]), k)}
                />
              </Card.Body>
            </Card>
          );
        })}
      </div>
    );
  }
}

MetricMetric.propTypes = {
  metric: PropTypes.array.isRequired,
}

export default MetricMetric;